import { makeStyles } from '@material-ui/core/styles';
import { TextColors, TextOpacities, SurfaceColors, BackgroundColors } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  root: {
    '&.is-info': {
      '& $authorName': {
        color: hexToRGBA(TextColors.light),
      },
      '& $authorCompany': {
        color: hexToRGBA(TextColors.light, TextOpacities.light2),
      },
      '& $bio': {
        color: hexToRGBA(TextColors.light, TextOpacities.light2),
      },
      '& $divider': {
        color: hexToRGBA(TextColors.light, TextOpacities.light3),
      },
    },

    '&.is-detail': {
      '& $authorName': {
        color: hexToRGBA(TextColors.dark),
      },
      '& $authorCompany': {
        color: hexToRGBA(TextColors.dark, TextOpacities.dark2),
      },
      '& $bio': {
        color: hexToRGBA(TextColors.dark, TextOpacities.dark2),
      },
      '& $divider': {
        color: hexToRGBA(TextColors.dark, TextOpacities.dark3),
      },

      '&$detail': {
        background: BackgroundColors.light,
      },
    },
  },
};

const lightTheme = {
  root: {
    '& $authorName': {
      color: hexToRGBA(TextColors.dark),
    },
    '& $authorCompany': {
      color: hexToRGBA(TextColors.dark, TextOpacities.dark2),
    },
    '& $bio': {
      color: hexToRGBA(TextColors.dark, TextOpacities.dark2),
    },
    '& $divider': {
      color: hexToRGBA(TextColors.dark, TextOpacities.dark3),
    },

    '&.is-detail': {
      '&$detail': {
        background: SurfaceColors.light,
      },
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      '&.is-info': {
        height: '54px',

        '& $authorName': {
          lineHeight: 'normal',
        },
      },
    },
    authorName: {},
    authorCompany: {
      '&.MuiTypography-root': {
        marginTop: '-9px',
      },
    },
    bio: {
      ...muiTheme.typography.body2,
    },
    divider: {
      margin: '0 4px',
    },
    info: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      alignContent: 'center',
    },
    detail: {
      borderRadius: '4px',
      padding: '0 20px 30px',
      textAlign: 'center',

      [muiTheme.breakpoints.up('md')]: {
        display: 'flex',
        padding: '40px',
        textAlign: 'left',

        '& > *:last-child:not(:first-child)': {
          marginLeft: '40px',
        },
      },
    },
    avatar: {
      '& img': {
        display: 'block',
      },

      '&.is-detail': {
        height: '100px',
        width: '100px',
        transform: 'translateY(-24px)',
        margin: '24px auto -4px',

        [muiTheme.breakpoints.up('md')]: {
          margin: '0',
          transform: 'none',
        },
      },

      '&.is-info': {
        marginRight: '24px',
        height: '54px',
        width: '54px',
      },
    },
  }),
  { name: 'GenBlogDetailAuthor' },
);

export default useStyles;
